import { useCompetitorsMediaInvestmentUrl } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentUrl';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { getPeriodOptionsForModel } from '@/utils/model';
import { useNavigate } from '@tanstack/react-router';

export const useCompetitorsMediaInvestmentTabs = () => {
    const navigate = useNavigate();
    const {
        project: { interval },
    } = useDashboardGlobalContext();
    const { search, params } = useCompetitorsMediaInvestmentUrl();
    const { period } = search;

    const availablePeriodOptions = getPeriodOptionsForModel(interval);

    const activeTabIndex = period
        ? Math.max(availablePeriodOptions.indexOf(period) || 0, 0)
        : 0;

    const onActiveTabChange = async (activeTab: number) => {
        await navigate({
            search: {
                ...search,
                period: availablePeriodOptions[activeTab] || '',
            },
            params,
        });
    };

    return {
        activeTabIndex,
        tabsToRender: availablePeriodOptions,
        onActiveTabChange,
    };
};
